import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationFlowmeterMake } from '../../../../@types/model/masterData/pumpingStation/flowMeterMake';
import MasterDataPumpingStationFlowmeterMakeFunctions from '../../../../store/masterData/pumpingStation/flowmeterMake/functions';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';

interface IPumpingStationFlowMeterMakeSelectorProps {
    value : string;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : string) => void;

    isLoading : boolean;
    flowMeterMakes : Array<IPumpingStationFlowmeterMake>;
}

interface IPumpingStationFlowMeterMakeSelectorState { }

class PumpingStationFlowMeterMakeSelectorComponent extends React.PureComponent<IPumpingStationFlowMeterMakeSelectorProps, IPumpingStationFlowMeterMakeSelectorState> {
    constructor(props : IPumpingStationFlowMeterMakeSelectorProps) {
        super(props);

        this.state = {};
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? '');
    };

    public componentDidMount() {
        MasterDataPumpingStationFlowmeterMakeFunctions.load();
    }

    private readonly getData = (state : IPumpingStationFlowMeterMakeSelectorState, props : IPumpingStationFlowMeterMakeSelectorProps) => props.flowMeterMakes;
    private readonly getValue = (state : IPumpingStationFlowMeterMakeSelectorState, props : IPumpingStationFlowMeterMakeSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationFlowMeterMakeSelectorState, props : IPumpingStationFlowMeterMakeSelectorProps) => props.required;


    private readonly getFlowMeterMakes = createSelector([
        this.getData,
    ], (flowMeterMakes) => flowMeterMakes.filter(x => x.isActive).map(x => x.name).sort((a, b) => a.localeCompare(b)));

    private readonly getFlowMeterMakesForDropdown = createSelector([ 
        this.getRequired, this.getFlowMeterMakes, 
    ], (required, flowMeterMakes) => {
        
        const dropdownData = lodash.map(flowMeterMakes, (element) => ({ label: `${element}`, value: element.toString() }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getFlowMeterMakes,
    ], (value, required, flowmeterMakes) => {
        if (value) {
            const flowmeterMake = flowmeterMakes.find(element => element === value);

            if (flowmeterMake) {
                return { label: flowmeterMake, value: flowmeterMake };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getFlowMeterMakesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'flowmeterMake'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Flowmeter Make'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.flowmeterMake.isLoading,
        flowMeterMakes: state.masterData.pumpingStation.flowmeterMake.flowmeterMakes,
    };
};

const PumpingStationFlowMeterMakeSelector = connect(
    mapStateToProps,
)(PumpingStationFlowMeterMakeSelectorComponent);

export default PumpingStationFlowMeterMakeSelector;